import { render } from "./ManufacturerProductsFilter.vue?vue&type=template&id=627bcb00"
import script from "./ManufacturerProductsFilter.vue?vue&type=script&lang=js"
export * from "./ManufacturerProductsFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__